import { useEffect, useMemo } from "preact/hooks";
import type { StoredImage } from "../types.js";

export interface ImageEntry {
  readonly id: string;
  readonly image: StoredImage;
}

export function useObjectUrls(entries: readonly ImageEntry[]): ReadonlyMap<string, string> {
  const key = entries.map((entry) => `${entry.id}:${entry.image.bytes.byteLength}`).join("|");
  const urls = useMemo(
    () =>
      new Map(
        entries.map((entry) => [
          entry.id,
          URL.createObjectURL(new Blob([entry.image.bytes], { type: entry.image.type })),
        ]),
      ),
    [key],
  );
  useEffect(
    () => () => {
      for (const url of urls.values()) {
        URL.revokeObjectURL(url);
      }
    },
    [urls],
  );
  return urls;
}
